import i18n from "i18next";
import { initReactI18next } from "react-i18next";

//Languages
import tr from "./tr.json";
import en from "./en.json";

const resources = {
  tr: {
    translation: tr,
  },
  en: {
    translation: en,
  },
};

i18n.use(initReactI18next).init({
  fallbackLng: "tr",
  resources,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
